import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container mx-auto pt-8 pb-16 px-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-100 text-3xl font-semibold pt-2" }, "Import Annotators Report", -1)
const _hoisted_3 = { class: "bg-white text-gray-700 p-4 mt-8 rounded-md shadow-md" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1 text-sm" }, "Date range:", -1)
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "inline-flex items-center px-3 border border-r-0 rounded-l-md border-gray-200 bg-gray-50 text-gray-500 text-sm" }
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1 text-sm" }, "Working Hours per Day:", -1)
const _hoisted_11 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6 mt-6" }
const _hoisted_12 = { class: "border border-gray-200 rounded-md p-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("legend", { class: "text-sm font-semibold px-2" }, "Honeydew", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1 text-sm" }, "Task (optional):", -1)
const _hoisted_15 = { class: "border border-gray-200 rounded-md p-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("legend", { class: "text-sm font-semibold px-2" }, "Cantaloupe", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1 text-sm" }, "Task (optional):", -1)
const _hoisted_18 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_19 = { class: "text-sm font-semibold text-red-700 mb-2" }
const _hoisted_20 = { class: "flex flex-col" }
const _hoisted_21 = { class: "overflow-x-auto" }
const _hoisted_22 = { class: "align-middle inline-block min-w-full" }
const _hoisted_23 = { class: "border overflow-hidden border-b border-gray-200 rounded-md" }
const _hoisted_24 = { class: "table-fixed min-w-full divide-y divide-gray-200" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
    }, "Source"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
    }, "Name"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
    }, "Email"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
    }, "External ID"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-left text-xs font-medium text-gray-500"
    }, "Reason")
  ])
], -1)
const _hoisted_26 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_27 = { class: "px-3 py-2 border-r text-sm" }
const _hoisted_28 = { class: "px-3 py-2 border-r text-sm" }
const _hoisted_29 = { class: "px-3 py-2 border-r text-sm" }
const _hoisted_30 = { class: "px-3 py-2 border-r text-sm" }
const _hoisted_31 = { class: "px-3 py-2 text-sm" }
const _hoisted_32 = { class: "flex mt-6 justify-end" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "Load Preview", -1)
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-semibold mb-4" }, "Preview", -1)
const _hoisted_36 = { class: "flex flex-col gap-6" }
const _hoisted_37 = { class: "text-sm font-semibold" }
const _hoisted_38 = {
  key: 0,
  class: "mt-2 overflow-x-auto"
}
const _hoisted_39 = { class: "min-w-full divide-y divide-gray-200 border border-gray-200 rounded-md" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-2 text-left text-xs font-medium text-gray-700" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-2 text-left text-xs font-medium text-gray-700" }, "Email"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-2 text-left text-xs font-medium text-gray-700" }, "External ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-2 text-left text-xs font-medium text-gray-700" }, "Project External ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-2 text-left text-xs font-medium text-gray-700" }, "Hours")
  ])
], -1)
const _hoisted_41 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_42 = { class: "px-3 py-2 text-sm" }
const _hoisted_43 = { class: "px-3 py-2 text-sm" }
const _hoisted_44 = { class: "px-3 py-2 text-sm" }
const _hoisted_45 = { class: "px-3 py-2 text-sm" }
const _hoisted_46 = { class: "px-3 py-2 text-sm" }
const _hoisted_47 = { class: "text-sm font-semibold" }
const _hoisted_48 = {
  key: 0,
  class: "mt-2 overflow-x-auto"
}
const _hoisted_49 = { class: "min-w-full divide-y divide-gray-200 border border-gray-200 rounded-md" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-2 text-left text-xs font-medium text-gray-700" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-2 text-left text-xs font-medium text-gray-700" }, "Email"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-2 text-left text-xs font-medium text-gray-700" }, "External ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-2 text-left text-xs font-medium text-gray-700" }, "Project External ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-2 text-left text-xs font-medium text-gray-700" }, "Hours")
  ])
], -1)
const _hoisted_51 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_52 = { class: "px-3 py-2 text-sm" }
const _hoisted_53 = { class: "px-3 py-2 text-sm" }
const _hoisted_54 = { class: "px-3 py-2 text-sm" }
const _hoisted_55 = { class: "px-3 py-2 text-sm" }
const _hoisted_56 = { class: "px-3 py-2 text-sm" }
const _hoisted_57 = { class: "flex mt-6 justify-end" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", null, "Back", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", null, "Confirm & Import", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_RefreshIcon = _resolveComponent("RefreshIcon")!
  const _component_SearchIcon = _resolveComponent("SearchIcon")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_UploadIcon = _resolveComponent("UploadIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.preview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_date_picker, {
                modelValue: _ctx.date,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
                masks: {input: 'D. M. YYYY'},
                popover: { visibility: 'focus' },
                "is-range": ""
              }, {
                default: _withCtx(({ inputValue, inputEvents, isDragging }) => [
                  _createElementVNode("div", null, [
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, [
                        _createVNode(_component_CalendarIcon, { class: "h-5 w-5" })
                      ]),
                      _createElementVNode("input", _mergeProps({
                        readonly: "",
                        class: ["flex-grow px-3 py-2 w-full rounded-md rounded-l-none border border-gray-200 text-sm text-gray-700", isDragging ? 'text-gray-500' : 'text-gray-700'],
                        value: _ctx.date.start && _ctx.date.end ? (inputValue.start + ' - ' + inputValue.end) : 'Select range'
                      }, _toHandlers(inputEvents.start)), null, 16, _hoisted_9)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "masks"]),
              _createElementVNode("div", null, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.workingHoursPerDay) = $event)),
                  type: "number",
                  min: "1",
                  max: "24",
                  step: "1",
                  class: "px-3 py-2 w-full rounded-md border border-gray-200 text-sm text-gray-700"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.workingHoursPerDay,
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("fieldset", _hoisted_12, [
                _hoisted_13,
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.honeydew.task) = $event)),
                  type: "text",
                  class: "px-3 py-2 w-full rounded-md border border-gray-200 text-sm text-gray-700"
                }, null, 512), [
                  [_vModelText, _ctx.honeydew.task]
                ])
              ]),
              _createElementVNode("fieldset", _hoisted_15, [
                _hoisted_16,
                _hoisted_17,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cantaloupe.task) = $event)),
                  type: "text",
                  class: "px-3 py-2 w-full rounded-md border border-gray-200 text-sm text-gray-700"
                }, null, 512), [
                  [_vModelText, _ctx.cantaloupe.task]
                ])
              ])
            ]),
            (_ctx.validationErrors.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("h2", _hoisted_19, "Validation errors (" + _toDisplayString(_ctx.validationErrors.length) + ")", 1),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("table", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("tbody", _hoisted_26, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validationErrors, (e, idx) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: `err-${idx}`,
                                  class: "hover:bg-gray-50"
                                }, [
                                  _createElementVNode("td", _hoisted_27, _toDisplayString(e.source), 1),
                                  _createElementVNode("td", _hoisted_28, _toDisplayString(e.name), 1),
                                  _createElementVNode("td", _hoisted_29, _toDisplayString(e.email), 1),
                                  _createElementVNode("td", _hoisted_30, _toDisplayString(e.externalId), 1),
                                  _createElementVNode("td", _hoisted_31, _toDisplayString(e.reason), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_app_button, {
                onClick: _ctx.loadPreview,
                type: _ctx.fetchInProgress ? 'blue-disabled' : 'blue',
                class: _normalizeClass(['w-full sm:w-auto'])
              }, {
                default: _withCtx(() => [
                  (_ctx.fetchInProgress)
                    ? (_openBlock(), _createBlock(_component_RefreshIcon, {
                        key: 0,
                        class: "h-5 w-5 mr-2 -ml-1 animate-spin"
                      }))
                    : (_openBlock(), _createBlock(_component_SearchIcon, {
                        key: 1,
                        class: "h-5 w-5 mr-2 -ml-1"
                      })),
                  _hoisted_33
                ]),
                _: 1
              }, 8, ["onClick", "type"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.honeydewExpanded = !_ctx.honeydewExpanded)),
                  class: "w-full flex justify-between items-center bg-gray-50 hover:bg-gray-100 p-3 rounded-md border border-gray-200"
                }, [
                  _createElementVNode("span", _hoisted_37, "Honeydew: " + _toDisplayString(_ctx.preview.honeydew.length) + " record(s)", 1),
                  _createVNode(_component_ChevronDownIcon, {
                    class: _normalizeClass(["h-5 w-5 transform transition-transform", {'rotate-180': _ctx.honeydewExpanded}])
                  }, null, 8, ["class"])
                ]),
                (_ctx.honeydewExpanded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("table", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("tbody", _hoisted_41, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preview.honeydew, (r, idx) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: `hd-${idx}`
                            }, [
                              _createElementVNode("td", _hoisted_42, _toDisplayString(r.name), 1),
                              _createElementVNode("td", _hoisted_43, _toDisplayString(r.email), 1),
                              _createElementVNode("td", _hoisted_44, _toDisplayString(r.externalId), 1),
                              _createElementVNode("td", _hoisted_45, _toDisplayString(r.projectExternalId), 1),
                              _createElementVNode("td", _hoisted_46, _toDisplayString(r.hours), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cantaloupeExpanded = !_ctx.cantaloupeExpanded)),
                  class: "w-full flex justify-between items-center bg-gray-50 hover:bg-gray-100 p-3 rounded-md border border-gray-200"
                }, [
                  _createElementVNode("span", _hoisted_47, "Cantaloupe: " + _toDisplayString(_ctx.preview.cantaloupe.length) + " record(s)", 1),
                  _createVNode(_component_ChevronDownIcon, {
                    class: _normalizeClass(["h-5 w-5 transform transition-transform", {'rotate-180': _ctx.cantaloupeExpanded}])
                  }, null, 8, ["class"])
                ]),
                (_ctx.cantaloupeExpanded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("table", _hoisted_49, [
                        _hoisted_50,
                        _createElementVNode("tbody", _hoisted_51, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preview.cantaloupe, (r, idx) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: `ct-${idx}`
                            }, [
                              _createElementVNode("td", _hoisted_52, _toDisplayString(r.name), 1),
                              _createElementVNode("td", _hoisted_53, _toDisplayString(r.email), 1),
                              _createElementVNode("td", _hoisted_54, _toDisplayString(r.externalId), 1),
                              _createElementVNode("td", _hoisted_55, _toDisplayString(r.projectExternalId), 1),
                              _createElementVNode("td", _hoisted_56, _toDisplayString(r.hours), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createVNode(_component_app_button, {
                onClick: _ctx.cancelPreview,
                type: "gray",
                class: "mr-2 w-full sm:w-auto"
              }, {
                default: _withCtx(() => [
                  _hoisted_58
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_app_button, {
                onClick: _ctx.confirmImport,
                type: _ctx.importInProgress ? 'blue-disabled' : 'blue',
                class: _normalizeClass(['w-full sm:w-auto'])
              }, {
                default: _withCtx(() => [
                  (_ctx.importInProgress)
                    ? (_openBlock(), _createBlock(_component_RefreshIcon, {
                        key: 0,
                        class: "h-5 w-5 mr-2 -ml-1 animate-spin"
                      }))
                    : (_openBlock(), _createBlock(_component_UploadIcon, {
                        key: 1,
                        class: "h-5 w-5 mr-2 -ml-1"
                      })),
                  _hoisted_59
                ]),
                _: 1
              }, 8, ["onClick", "type"])
            ])
          ]))
    ])
  ]))
}